import type { Theme } from '@mui/material';
import { styled, Typography } from '@mui/material';

export const Item = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'selected',
})(({ theme, selected }: { theme?: Theme; selected: boolean }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '40px',
  height: '40px',
  color: selected ? theme?.palette.primary.main : theme?.palette.primary.light,
  fontWeight: selected ? 700 : 400,
  cursor: 'pointer',
  background: selected ? theme?.palette.secondary.main : 'transparent',
  borderRadius: '8px',
  [theme!.breakpoints.down('sm')]: {
    width: '32px',
    height: '32px',
  },
}));

export const Dots = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '40px',
  height: '40px',
  color: theme.palette.primary.main,
}));
